import { find } from 'lodash-es';

import * as angular from 'angular';

interface PromiseToTrack {
  promise: string;
  promiseResolved: boolean;
}

interface PromiseTracker {
  promises: PromiseToTrack[];
  successFn?();
  failFn?();
  onSuccess(fn);
  onFail(fn);
  waitFor(promise);
  checkIfAllAreResolved();
  areAllPromisesResolved();
}

// TODO: Convert to service
export default function PromiseTrackerFactory($q) {
  'ngInject';

  var i = 0;

  // we're esssentially implementing a dynamic $q.all since we want to be able to add promises after $q.all resolves

  var tracker: PromiseTracker = {
    onSuccess: function (fn) {
      tracker.successFn = fn;
    },
    onFail: function (fn) {
      tracker.failFn = fn;
    },
    promises: [],
    waitFor: function (promise) {
      var promiseName = 'promise' + i++;

      // add it to the queue
      tracker.promises.push({
        promise: promiseName,
        promiseResolved: false
      });

      function markAsResolved() {
        // find and mark it as resolved
        var thePromise = find(tracker.promises, {
          promise: promiseName
        });
        thePromise.promiseResolved = true;

        tracker.checkIfAllAreResolved();
      }

      // Note: We're using the same function for both resolved and rejected
      // promises. That's because earlier versions did not treat a rejected
      // promise as ever having completed and thus the loading indicator
      // would never go away if any of the API calls a page made resulted in a rejection.
      promise.then(markAsResolved, markAsResolved);

      // if all promises are resolved
      tracker.checkIfAllAreResolved();
    },
    checkIfAllAreResolved: function () {
      if (tracker.areAllPromisesResolved()) {
        tracker.successFn && tracker.successFn();
      } else {
        tracker.failFn && tracker.failFn();
      }
    },
    areAllPromisesResolved: function () {
      var allResolved = true;

      angular.forEach(tracker.promises, function (obj, index) {
        if (!obj.promiseResolved) {
          allResolved = false;
        }
      });

      return allResolved;
    }
  };

  return tracker;
}
